import React, { FC } from 'react';
import { FlexCol, FlexRow, SimpleDivider } from '@minecraft.atoms';
import { AddressChange } from '@blocs.address-suggestion';
import { UseBilling } from '../../useBilling';
import { PaywallFunnelEvents } from '../../usePaywallFunnelEvents';
import { BillingAddressFormLayout } from './BillingAddressFormLayout';
import { CreditCardDetailsFormLayout } from './CreditCardDetailsFormLayout';

export type CreditCardFieldsProps = {
  isMobile?: boolean;
  selectedCard?: UseBilling['wallet'][0];
  // Controls the new-design expiration/CVV layout + the Billing Address section (Country, Address
  // Line 1/2, City, State, Zip Code). When false, falls back to the pre-billing-address design:
  // separate Month*/Year* fields and CVV*/Zip* side by side, no billing address section at all.
  isPaywallBillingAddressEnabled?: boolean;
  onAddressLine1Change: (change: AddressChange) => void;
  funnelEvents?: PaywallFunnelEvents;
};

export const CreditCardFields: FC<CreditCardFieldsProps> = ({
  isMobile,
  selectedCard,
  isPaywallBillingAddressEnabled,
  onAddressLine1Change,
  funnelEvents,
}) => {
  return (
    <FlexCol gap="6">
      <CreditCardDetailsFormLayout
        firstNamePlaceholder={selectedCard?.firstName || 'John'}
        lastNamePlaceholder={selectedCard?.lastName || 'Smith'}
        cardNumberPlaceholder={selectedCard?.id ? `**** **** **** ${selectedCard?.lastFour}` : '1234 1234 1234 1234'}
        monthPlaceholder={selectedCard?.month?.toString()}
        yearPlaceholder={selectedCard?.year?.toString()}
        isMobile={isMobile}
        isBillingAddressFieldEnabled={isPaywallBillingAddressEnabled}
      />
      {isPaywallBillingAddressEnabled && (
        <FlexRow w="full">
          <SimpleDivider />
        </FlexRow>
      )}
      <BillingAddressFormLayout
        isBillingAddressFieldEnabled={isPaywallBillingAddressEnabled}
        onAddressLine1Change={onAddressLine1Change}
        funnelEvents={funnelEvents}
      />
    </FlexCol>
  );
};
